@if (currentZone==='true') {
	@if (mobileView) {
		<div class="text-truncate" style="font-size: 12px; max-width: 250px; margin-left: 5px; color:#000;">({{user.ZoneDisplayName}})</div>
	}
	@if (!mobileView) {
		<div class="text-truncate rounded mx-auto" style="font-size: 10px; max-width: 200px; background-color: #fff; color: #000; padding: 0px 3px;">{{user.ZoneDisplayName}}</div>
	}
}

@if (canSwitch && currentZone==='false') {
	<hr />
	<div style="margin-left:10px">
		<div [style]="{'color':(mobileView?'#000':'#7f8c8d')}" style="padding:8px 0px;">Switch Accounts</div>
		<table class="table table-borderless">
			<colgroup><col style="width:20px;" /><col /></colgroup>
			<tbody>
				@for (zone of oAccounts; track zone) {
				<tr>
					<td>
						<div [style]="{'color':(mobileView?'#000':'#7f8c8d')}">{{zone.Zone}}</div>
						<ul class="m-0 p-0 ps-4">
							@for (acc of zone.Accounts; track acc) {
							<li (click)="changeAccount(acc.PersonId)" role="button" [class]="{'text-primary':mobileView, 'jmDropdownItem':!mobileView}">
								{{acc.RoleName}}
							</li>
							}
						</ul>
					</td>
				</tr>
				}
			</tbody>
		</table>
	</div>
	<hr />
}
